import PropTypes from 'prop-types';
import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from 'react';

import { useAuth } from '../../security/authContext';
import ListaDocumentosActionTypes from './actions';
import { DOCUMENTOS_INICIAL, ListaDocumentosReducer } from './reducer';

const ListaDocumentosContext = createContext();

export function useListaDocumentosContext() {
  const context = useContext(ListaDocumentosContext);
  return context;
}

export default function ListaDocumentosProvider({ children }) {
  const { user } = useAuth();

  const [listaDocumentos, dispatch] = useReducer(
    ListaDocumentosReducer,
    DOCUMENTOS_INICIAL
  );

  const updateDocumentosAction = useCallback(
    (documentosMotorista, statusViagem) => {
      dispatch({
        type: ListaDocumentosActionTypes.UPDATE,
        payload: { documentosMotorista, statusViagem },
      });
    },
    []
  );

  const loadingDocumentoAction = (tipoDocumento, loading) => {
    dispatch({
      type: ListaDocumentosActionTypes.LOADING,
      payload: { tipoDocumento, loading },
    });
  };

  const editDocumentoAction = tipoDocumento => {
    dispatch({
      type: ListaDocumentosActionTypes.EDIT,
      payload: tipoDocumento,
    });
  };

  const removeDocumentoAction = (tipoDocumento, id) => {
    dispatch({
      type: ListaDocumentosActionTypes.REMOVE,
      payload: { id, tipoDocumento },
    });
  };

  const addDocumentoAction = (tipoDocumento, id) => {
    dispatch({
      type: ListaDocumentosActionTypes.ADD,
      payload: { id, tipoDocumento, idUsuarioShipper: user.id },
    });
  };

  return (
    <ListaDocumentosContext.Provider
      value={{
        listaDocumentos,
        updateDocumentosAction,
        loadingDocumentoAction,
        editDocumentoAction,
        removeDocumentoAction,
        addDocumentoAction,
        dispatch,
      }}
    >
      {children}
    </ListaDocumentosContext.Provider>
  );
}

ListaDocumentosProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ListaDocumentosContext.displayName = 'ListaDocumentosContext';
